import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styles from '../SetupWizard.module.css';

/**
 * Erro da etapa + "Voltar" e a ação principal, presos no rodapé do cartão
 * (sempre visíveis, mesmo quando a etapa é mais alta que a tela).
 * `primaryAsLink`: a ação vira um link discreto, para quando outra ação da etapa
 * é a principal (o "Enviar teste" do passo do WhatsApp).
 */
function StepFooter({ error, onBack, primaryLabel = 'Continuar', onPrimary, disabled, saving, extra, primaryAsLink = false }) {
  return (
    <div className={styles.footerBar}>
      {error && <div className={styles.errorBox} role="alert">{error}</div>}
      <div className={styles.footer}>
        {onBack && (
          <button type="button" className={styles.textButton} onClick={onBack} disabled={saving}>
            <ArrowBackIcon fontSize="inherit" style={{ verticalAlign: -2, marginRight: 4 }} />
            Voltar
          </button>
        )}
        <div className={styles.footerEnd}>
          {extra}
          {primaryAsLink ? (
            <button type="button" className={styles.linkButton} onClick={onPrimary} disabled={disabled || saving}>
              {saving ? 'Salvando...' : primaryLabel}
            </button>
          ) : (
            <button type="button" className={styles.primaryButton} onClick={onPrimary} disabled={disabled || saving}>
              {saving ? 'Salvando...' : primaryLabel}
              {!saving && <ArrowForwardIcon fontSize="small" />}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default StepFooter;
